import React from 'react'

import {
  EuiCard,
  EuiIcon,
  EuiFlexGroup,
  EuiFlexItem
} from '@elastic/eui'


export default function APIGlossar() {

  return (
    <div style={{ padding: 15 }}>
      <EuiFlexGroup gutterSize="m">
        <EuiFlexItem>
          <EuiCard
            icon={<EuiIcon size="xxl" type="function" />}
            title="Kamera Parameter"
            description=""
          />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiCard
            icon={<EuiIcon size="xxl" type="filebeatApp" />}
            title="Parameter Details"
            description=""
          />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiCard
            icon={<EuiIcon size="xxl" type="consoleApp" />}
            title="CGI SET Befehl"
            description=""
          />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiCard
            icon={<EuiIcon size="xxl" type="gisApp" />}
            title="Werte Bereich"
            description=""
          />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiCard
            icon={<EuiIcon size="xxl" type="graphApp" />}
            title="MQTT Topic"
            description=""
          />
        </EuiFlexItem>
      </EuiFlexGroup>
    </div>
  );
}